import lscache from 'lscache';
import OAuthButton from 'modules/authentication/components/AuthButtons/OAuthButton';
import { signIn } from 'modules/authentication/helpers/nextauth';
import React, { useState } from 'react';

type GoogleLoginProps = {
  isLogin?: boolean;
  callbackUrl?: string;
  onLoginResult: (
    state: any,
  ) => ({
    error,
    success,
    redirectUrl,
  }: {
    error?: any;
    success: boolean;
    redirectUrl?: string;
  }) => void;
  afterLogin?: () => boolean;
  isLastUsed?: boolean;
};
const INITIAL_STATE = {
  loading: false,
  error: null,
};

function GoogleLogin({
  isLogin,
  callbackUrl,
  afterLogin,
  onLoginResult,
  isLastUsed,
}: GoogleLoginProps) {
  const [state, setState] = useState(INITIAL_STATE);
  const onLoginClick = async () => {
    setState({ error: null, loading: true });
    try {
      await signIn('google', callbackUrl, onLoginResult(setState));
      lscache.set('lastUsedProvider', 'google');
      const hideLoading = afterLogin?.();
      if (hideLoading) {
        setState({ error: null, loading: false });
      }
    } catch (exception) {
      setState({ error: exception, loading: false });
    }
  };

  return (
    <OAuthButton
      onClick={onLoginClick}
      provider="google"
      isLogin={isLogin}
      isLoading={state.loading}
      hasError={!!state.error}
      isLastUsed={isLastUsed}
    />
  );
}

export default GoogleLogin;
